import { Capacitor, registerPlugin } from '@capacitor/core';

// Native share sheet of the @capacitor/share plugin (its native code is part of the Android/iOS app).
// Registered by name, so the website build does not need the plugin's JavaScript package.
let sharePlugin = null;
const nativeShare = () => {
  if (!sharePlugin) sharePlugin = registerPlugin('Share');
  return sharePlugin;
};

// Public address of the website (inside the Android app window.location is https://localhost).
export const PUBLIC_URL = 'https://socraquest.sk';

export const groupInviteLink = (code) => `${PUBLIC_URL}/groups/join/${encodeURIComponent(code || '')}`;
// Personal invite code: from the signed-in user, or fetched from the server (older sessions/accounts had none)
export async function myReferralCode(user, fetchStats) {
  if (user?.referral_code) return user.referral_code;
  try {
    const res = await fetchStats();
    return res?.data?.referral_code || '';
  } catch (e) {
    return '';
  }
}

export const referralLink = (code) => (code ? `${PUBLIC_URL}/register?ref=${encodeURIComponent(code)}` : `${PUBLIC_URL}/register`);

async function copy(value) {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Opens the phone's share sheet (WhatsApp, Messenger, SMS, e-mail ...).
 * Android/iOS app: native share sheet; browser: Web Share API; otherwise the text is copied.
 * @returns {Promise<'shared'|'cancelled'|'copied'|'failed'>}
 */
export async function shareLink({ title = 'SocraQuest', text = '', url }) {
  const full = text ? `${text}\n${url}` : url;
  if (Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('Share')) {
    try {
      await nativeShare().share({ title, text, url, dialogTitle: title });
      return 'shared';
    } catch (e) {
      if (/cancel/i.test(String(e?.message || e))) return 'cancelled';
    }
  } else if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return 'shared';
    } catch (e) {
      if (e?.name === 'AbortError') return 'cancelled';
    }
  }
  return (await copy(full)) ? 'copied' : 'failed';
}

export async function copyText(value) {
  return copy(value);
}

export const whatsappHref = (text, url) => `https://wa.me/?text=${encodeURIComponent(text ? `${text}\n${url}` : url)}`;
export const emailHref = (subject, text, url) =>
  `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text ? `${text}\n\n${url}` : url)}`;
export const smsHref = (text, url) => `sms:?&body=${encodeURIComponent(text ? `${text} ${url}` : url)}`;
